import React, {useContext, useEffect, useRef, useState} from 'react'
import OfferMultiPositions from "./OfferMultiPositions";
import OfferSinglePosition from "./OfferSinglePosition";
import TitledComponent from "components/TitledComponent";
import {connect} from "react-redux";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {makeStyles, TextField} from "@material-ui/core";
import PropTypes from "prop-types";
import {OfferMode} from "../../../../common/constants/OfferMode";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import OfferSectionContext from "context/OfferSectionContext";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import {RoundType} from "constants/RoundType";
import IconButton from "components/button/IconButton";
import Tr from "translations/Translations";
import WorkableIconButton from "components/button/WorkableIconButton";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import GridBlock from "components/GridBlock";
import purchaserOfferContext from "context/PurchaserOfferContext";
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {OfferPositionStatusType} from "../../../../common/constants/OfferPositionStatusType";

const useStyle = makeStyles(theme => ({
    root: {
        height: '100%',
        // '&>*:not(:first-child)': {
        //     marginTop: theme.spacing(2)
        // }
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        bottom: 0
    },
    menuBarPaper: {
        background: theme.palette.background.default,
        border: `solid 1px ${theme.palette.border.dark}`,
    },
    search: {
        marginBottom: theme.spacing(2),
        width: 470,
    }
}))


function OfferPositions(
    {
        offerEdit,
        positionsLoaded = {},
        disabled,
        mode,
        positionsRef,
        roundType
    }) {

    const classes = useStyle();
    const contextSection = useContext(OfferSectionContext);
    const [searchReg, setSearchReg] = useState(null);
    const [hideNoOfferPositionsOperator, setHideNoOfferPositionsOperator] = useState(purchaserOfferContext && mode === OfferMode.PLACED);
    const searchText = useRef();

    useEffect(() => {
        return () => {
            switch (roundType) {
                case RoundType.BASE:
                    DemandOffersOfferService.clearResources(DemandOffersOfferService.OFFER_POSITIONS_LOADED);
                    break;
                case RoundType.ADDITIONAL_OFFERS:
                    DemandAdditionalOffersOfferService.clearResources(DemandAdditionalOffersOfferService.ADDITIONAL_OFFER_POSITIONS_LOADED);
                    break;
                case RoundType.AUCTION:
                    DemandOffersAuctionService.clearResources(DemandOffersAuctionService.AUCTIONS_OFFER_POSITIONS_LOADED)
                    break;
                default:
                    throw new Error("Unknown roundType: " + roundType)
            }

        }
        // eslint-disable-next-line
    }, [])

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            handleSubmit()
        }
    }

    const handleSubmit = (clear) => {
        if (clear) {
            searchText.current.value = ""
        }
        if (searchText.current.value && searchText.current.value !== "") {
            setSearchReg(new RegExp(searchText.current.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "i"));
        } else {
            setSearchReg(null)
        }
    }

    return (<TitledComponent componentRef={positionsRef} className={classes.root}>

        {!contextSection.onePositionMode ? <>
                {
                    offerEdit.positions.length > 1 && <GridBlock className={classes.root}>

                        <TextField
                            className={classes.search}
                            label={Tr('search_part')}
                            fullWidth
                            inputProps={{onKeyPress: handleKeyUp}}
                            inputRef={searchText}
                        />


                        <div>
                            <WorkableIconButton Icon={SearchIcon} onClick={() => handleSubmit()} tooltip={Tr('search')}/>
                            <IconButton Icon={ClearIcon} tooltip={Tr('clear')} onClick={() => handleSubmit(true)}/>
                            {
                                purchaserOfferContext && mode === OfferMode.PLACED && offerEdit.positions.some(x => x.status === OfferPositionStatusType.NO_OFFER) &&
                                <IconButton color="primary" Icon={hideNoOfferPositionsOperator ? VisibilityOff: Visibility} onClick={() => setHideNoOfferPositionsOperator(x => !x)}
                                            tooltip={hideNoOfferPositionsOperator ? Tr("show_no_offer_parts") : Tr("hide_no_offer_parts")}/>
                            }
                        </div>

                    </GridBlock>
                }
                <div>
                    {
                        offerEdit.positions.map(x => (<OfferMultiPositions
                            key={x.identity}
                            mode={mode}
                            position={x}
                            positionsLoaded={positionsLoaded}
                            disabled={disabled}
                            roundType={roundType}
                            offerEdit={offerEdit}
                            hide={(hideNoOfferPositionsOperator && x.status === OfferPositionStatusType.NO_OFFER) || (!!searchReg && (Tr('part_x', {x: x.order}) + ": " + x.name).search(searchReg) === -1)}
                        />))
                    }
                </div>
            </>
            : <OfferSinglePosition
                mode={mode}
                position={offerEdit.positions[0]}
                positionsLoaded={positionsLoaded}
                disabled={disabled}
                roundType={roundType}
                offerEdit={offerEdit}
            />
        }

    </TitledComponent>)
}

OfferPositions.propTypes = {
    mode: PropTypes.oneOf(Object.keys(OfferMode)).isRequired,
    roundType: PropTypes.oneOf(Object.keys(RoundType)).isRequired,
};

export default connect((state, ownProps) => ({
    positionsLoaded: state.resources[ownProps.roundType === RoundType.BASE ? DemandOffersOfferService.OFFER_POSITIONS_LOADED : (ownProps.roundType === RoundType.ADDITIONAL_OFFERS ? DemandAdditionalOffersOfferService.ADDITIONAL_OFFER_POSITIONS_LOADED : DemandOffersAuctionService.AUCTIONS_OFFER_POSITIONS_LOADED)],
}), {})(OfferPositions);